import {
  LatestSiteData,
  TiltLatestSiteData,
} from 'src/app/shared/interfaces/latest-site-data';

import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';

import { AccountService } from 'src/app/shared/services/account.service';
import { Site } from 'src/app/shared/interfaces/site';
import { UtilFunctions } from 'src/app/shared/utils/util-functions';

@Component({
  selector: 'app-site-detail-tilt-alert',
  templateUrl: './site-detail-tilt-alert.component.html',
  styleUrls: ['./site-detail-tilt-alert.component.scss'],
})
export class SiteDetailTiltAlertComponent implements OnChanges {
  @Input() site: Site | null = null;
  @Input() latestSiteData: LatestSiteData | null = null;

  private accountService = inject(AccountService);

  // TILT基準値アラートセンサー配列
  managementAlertSensors: TiltLatestSiteData[] = [];
  // TILT時間アラートセンサー配列
  hourlyAlertSensors: TiltLatestSiteData[] = [];

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    // センサーデータがない場合は何もしない
    if (this.latestSiteData?.sensorData === undefined) {
      return;
    }

    // TILTセンサーデータ取得
    const tiltSensorData: TiltLatestSiteData[] | undefined =
      this.latestSiteData.sensorData.tilt;

    // アラートセンサー配列を初期化
    this.managementAlertSensors = [];
    this.hourlyAlertSensors = [];

    // TILTセンサー配列の中でどれか1つでもアラート日時があれば、アラートセンサー配列に追加する
    // センサー配列の要素の中にそれぞれのセンサーのアラート日時が格納されている
    if (tiltSensorData !== undefined) {
      for (let sensorData of tiltSensorData) {
        // 基準値アラート日時取得
        if (
          sensorData.managementAlertDate !== undefined &&
          UtilFunctions.isWithinMinutes(sensorData.managementAlertDate, 60)
        ) {
          this.managementAlertSensors.push(sensorData);
        }
        // 1時間毎アラート日時取得
        if (
          sensorData.hourlyAlertDate !== undefined &&
          UtilFunctions.isWithinMinutes(sensorData.hourlyAlertDate, 60)
        ) {
          this.hourlyAlertSensors.push(sensorData);
        }
      }
    }
  }
}
